import { render, staticRenderFns } from "./FormSubmitButton.vue?vue&type=template&id=4ca34a98&"
import script from "./FormSubmitButton.vue?vue&type=script&lang=js&"
export * from "./FormSubmitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca34a98')) {
      api.createRecord('4ca34a98', component.options)
    } else {
      api.reload('4ca34a98', component.options)
    }
    module.hot.accept("./FormSubmitButton.vue?vue&type=template&id=4ca34a98&", function () {
      api.rerender('4ca34a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/buttons/FormSubmitButton.vue"
export default component.exports